





























import { defineComponent } from "@vue/composition-api";
import { ContentPriceSubjectTypeEnum } from "@scrile/api-provider/dist/api/ContentPriceProvider";
import { PaymentPackage } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import { PaymentSystemPublic } from "@scrile/api-provider/dist/api/PaymentSystemsProvider";
import { formatMoneyString, getMainCurrencyCode, isCryptoSystem } from "@/lib/moneyHelpers";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import BaseSpinner from "@/components/BaseSpinner";
import ChoosePaymentSystem from "@/components/ChoosePaymentSystem";

export default defineComponent({
  name: "PurchaseConfirmationView",
  components: { BaseConfirm, BaseButton, BaseSpinner, ChoosePaymentSystem },
  props: {
    value: { type: Boolean, required: true },
    packageId: { type: String, required: true },
    paymentPackages: { type: Array as () => PaymentPackage[], required: true },
    loadingData: { type: Boolean, required: true },
    subjectId: { type: String, required: true },
    paymentSystemsPublic: { type: Array as () => PaymentSystemPublic[], required: true },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    purchaseSubjectType() {
      return ContentPriceSubjectTypeEnum.MESSAGE_ATTACHMENT;
    },
    hasCrypto(): boolean {
      return this.paymentSystemsPublic.some(p => isCryptoSystem(p.type));
    },
    price(): string {
      let amount = this.paymentPackages
        .find(pkg => pkg.id === this.packageId)
        ?.costs.find(cost => cost.currency === getMainCurrencyCode())?.cost;
      return (amount && formatMoneyString(amount, { currencyCode: getMainCurrencyCode() })) || "";
    },
  },
  methods: {
    onChooseSystem(paymentSystemType: string) {
      if (!isCryptoSystem(paymentSystemType)) {
        this.purchase(this.handleClose);
      }
    },
    handleClose() {
      this.$emit("input", false);
    },
    purchase(cb: Function) {
      this.loading = true;
      this.$emit("purchase", (success: boolean = true) => {
        this.loading = false;
        success && cb();
      });
    },
  },
});
